export default class ParallaxImage {
    constructor(options) {
        this.wrap = options.wrap;
        this.item = options.item;
        this.speedAttr = parseFloat(options.speedAttr) || 1; // デフォルト値は1
        this.winHeight = window.innerHeight; // ウィンドウの高さ
        this.frameId = null; // requestAnimationFrameのID
        this.isVisible = false; // 要素が画面内にあるかどうか
        this.lastPosition = -1; // スクロール位置の記録
        this.boundHandleResize = this.handleResize.bind(this); // リサイズ関数のバインド
        this.addDOMContentLoadedListener(); // DOMContentLoadedのリスナー追加
    }

    // DOMContentLoaded イベントリスナーの追加
    addDOMContentLoadedListener() {
        document.addEventListener('DOMContentLoaded', () => {
            this.init(); // 初期化
        });
    }

    // 初期化
    init() {
        if (!this.wrap || !this.item) return;

        this.item.style.transform = 'translate3d(0,0,0)'; // トランスフォームをリセット

        this.setupListeners(); // イベントリスナーの設定
        this.setupParallax(); // パララックスの設定
    }

    // イベントリスナーの設定
    setupListeners() {
        window.addEventListener('resize', this.boundHandleResize); // リサイズ時の処理
    }

    // リサイズ時の処理
    handleResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
            this.winHeight = window.innerHeight; // ウィンドウの高さを更新
            this.updatePosition(); // 要素の位置を更新
            if (this.isVisible) {
                cancelAnimationFrame(this.frameId); // 現在のアニメーションフレームをキャンセル
                this.item.style.transform = 'translate3d(0,0,0)'; // トランスフォームをリセット
                this.frameId = requestAnimationFrame(this.parallaxFunction); // パララックス効果を再開
            }
        }, 100);
    }

    // パララックスの設定
    setupParallax() {
        this.updatePosition(); // 要素の位置を取得
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                this.isVisible = entry.isIntersecting;
                if (this.isVisible) {
                    this.updatePosition(); // 要素の位置を取得
                    this.item.style.willChange = 'transform'; // パフォーマンス向上のためにwill-changeを設定
                    this.frameId = requestAnimationFrame(this.parallaxFunction); // requestAnimationFrameを実行
                } else {
                    cancelAnimationFrame(this.frameId); // 画面外に出た場合はrequestAnimationFrameをキャンセル
                    this.item.style.willChange = ''; // will-changeを削除
                }
            });
        }, { threshold: [0.1, 0.9] }); // 画面内に入った時の閾値を最適化
        observer.observe(this.wrap); // 画面内に入った時の監視
    }

    // 要素の位置を取得
    parallaxFunction = () => {
        const scrollTop = window.scrollY;
        if (this.lastPosition !== scrollTop) { // スクロール位置が変わった場合
            this.updateParallax(scrollTop); // パララックスの更新
            this.lastPosition = scrollTop; // スクロール位置を記録
        }
        if (this.isVisible) {
            this.frameId = requestAnimationFrame(this.parallaxFunction);
        }
    }

    // パララックスの更新
    updateParallax(scrollTop) {
        const scrollBottom = scrollTop + this.winHeight; // スクロールの最下部
        const setVal = ((scrollBottom - this.offsetTop) * this.scrollRatio * this.speedAttr).toFixed(1); // 移動量の計算
        this.item.style.transform = `translate3d(0,${-setVal}px,0)`;
    }

    // 要素の位置を取得
    updatePosition() {
        this.offsetTop = this.wrap.getBoundingClientRect().top + window.scrollY; // 要素の上端の位置
        const targetHeight = this.wrap.clientHeight; // 要素の高さ
        this.scrollRatio = (this.item.clientHeight - targetHeight) / (this.winHeight + targetHeight); // スクロール量の比率
    }

    // イベントリスナーの削除
    destroy() {
        window.removeEventListener('resize', this.boundHandleResize); // リスナーの削除
    }
}